<template>
    <v-container fluid class="fill-height" style="overflow-x: auto;">
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row dense>
            <v-col cols="12" md="2">
                <v-select
                    v-model="classId"
                    :items="items"
                    label="选择班级"
                    hide-details
                    item-text="className"
                    item-value="id"
                    solo
                    @change="initialize"
                ></v-select>
            </v-col>
            <v-col cols="12" class="ml-8" md="2" v-5="permissionCode.showName">
                <v-switch v-model="nameSwitch" @change="changeNameSwitch" label="是否只显示名字"></v-switch>
            </v-col>
        </v-row>
        <v-row>
            <v-col>

                <div class="contain" @contextmenu.prevent="showAddMenu" id="printTest" ref="dragContain">
                    <v-menu
                        v-model="addMenu"
                        :position-x="x"
                        :position-y="y"
                        absolute
                        offset-y
                    >
                        <v-list dense>
                            <v-list-item-group color="primary">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title @click="addDive">添加临时座位</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-menu>

                    <template v-for="(item,index) in dataPack.json">
                        <div class="drag" :class="{active:index == divindex}" v-if="dataPack.json.length"
                             :style="item.style">
                            {{item.text}}
                        </div>
                    </template>
                    <template v-for="(item,index) in dataSavePack.temporarySeat">
                        <div v-drag2="contain" class="drag" :class="{active:index == selectDivIndex}"
                             @click="moveDiv(index,$event)"
                             @mousemove="selectDivIndex = index" @mouseout.stop="selectDivIndex = -1"
                             :style="item.style">
                            <v-icon class="del" @mousemove="selectDivIndex = index" @mouseout.stop="selectDivIndex = -1"
                                    color="red" v-show="index == selectDivIndex" small @click="del(index,$event)">
                                mdi-delete
                            </v-icon>
                        </div>
                    </template>
                    <template v-for="(item,index) in dataPack.students">
                        <div v-drag="contain" class="drag" v-show="studentShow(item.id)"
                             :style="item.style" @mousemove="nameIndex = index" @mouseout="nameIndex = -1">
                            {{item.text}}
                        </div>
                    </template>
                    <template v-for="(items,indexs) in dataPack.seats">
                        <template v-for="(item,index) in items">
                            <div class="drag"
                                 :style="item.style"
                                 @dblclick="clearSeat(indexs,item.stuId)"
                            >
                                {{item.text}}
                            </div>
                        </template>
                    </template>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn v-5="permissionCode.save" @click="onSave">保存模板</v-btn>
                <v-btn v-5="permissionCode.print" @click="divindex = -1" v-print="'#printTest'">打印</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import arrayUtil from "@/utils/util/ArrayUtil"

    export default {
        name: "RowOfSeats",
        data() {
            return {
                permissionCode:{
                    save:'biz:class:row:save:template',
                    print:'biz:class:row:print',
                    showName:'biz:class:row:show:name',
                },
                selectDivIndex: -1,
                addMenu: false,
                dataPack: {
                    json: [],
                    students: [],
                    person: [],
                    seats: [],
                },
                dataSavePack: {
                    temporarySeat: [],
                    studentSeatCorrespondence: [],
                },
                name: "",
                //菜单位置
                x: 0,
                y: 0,
                //块位置
                offsetX: 0,
                offsetY: 0,
                //外层容器的宽高 数值不带px单位
                contain: {
                    xx: 500,
                    yy: 500
                },
                //记录原始位置
                originalLocation: {
                    left: 0,
                    top: 0
                },
                divindex: -1,//当前选中div的序号  默认为0
                nameIndex: -1,
                classId: '',
                className: '',
                stuCount: 0,
                legendColor: {
                    lastResult: '',
                    result: '',
                    lastRank: '',
                    rank: ''
                },
                transferStaff: {},
                items: [],
                nameSwitch:false,
                examName:{
                    thisExamName:'',
                    lastExamName:''
                },
                overlay:false,
            }
        },
        async created() {
            this.overlay = true;
            this.classId = this.$route.params.classId;
            if (!this.classId) {
                setTimeout(()=>{
                    this.$dialog.alert("请先选择班级");
                    this.$router.push("/class");
                },100)
                return;
            }
            this.$api.classList.getAllClass({
                params: {
                    type:'0'
                }
            }).then(data => {
                for (let i = 0; i < 5; i++) {
                    this.items.push(data.data[i]);
                }
            });
            await this.initialize();
        },
        methods: {
            async init() {
                const howManyInAColumn = 13;

                await this.$api.classList.getClassById(this.classId).then(data => {
                    this.className = data.data.className;
                    try {
                        this.dataPack.json = JSON.parse(data.data.classModel);
                    } catch (e) {
                        this.dataPack.json = null;
                    }
                    try {
                        this.dataSavePack = JSON.parse(data.data.seatSetting);
                    } catch (e) {
                        this.dataSavePack = null;
                    }
                    if (!this.dataSavePack) {
                        this.dataSavePack = {
                            temporarySeat: [],
                            studentSeatCorrespondence: [],
                        }
                    }
                    if (!this.dataPack.json || this.dataPack.json.length == 0) {
                        if(!data.data.classRoomId){
                            this.$dialog.alert("请先安排教室");
                            this.$router.push("/class");
                            return;
                        }
                        this.$api.bizClassRoom.selectClassRoom(data.data.classRoomId).then(data2 => {
                            this.dataPack.json = JSON.parse(data2.data.model);
                        });
                    }
                });

                await this.$api.achievement.getAchievement({
                    classId: this.classId
                }).then(data => {
                    let student = [];
                    this.stuCount = data.data.length;
                    for (let obj of data.data) {
                        let stu = {};
                        if(this.nameSwitch){
                            stu = {
                                id: obj.studentId,
                                name: obj.studentName,
                            };
                        }else{
                            stu = {
                                id: obj.studentId,
                                name: obj.studentName,
                                school: obj.schoolNickName,
                                lastResult: obj.lastScoreStr,
                                result: obj.thisScoreStr,
                                rank: obj.thisRankStr,
                                lastRank: obj.lastRankStr,
                            };
                        }

                        student.push(stu);
                        if (obj.transferTimes > 0) {
                            this.transferStaff[obj.studentId] = obj.transferTimes;
                        }
                    }
                    let col = 0;
                    for (let i in student) {
                        let temp = {
                            "style": {
                                "width": "80px",
                                "height": "40px",
                                "fontSize": "18px",
                                "color": "#000",
                                "top": "560px",
                                "left": "1040px",
                                "border": "1px solid rgb(0, 0, 0)",
                                "backgroundColor": "rgb(255, 255, 255)",
                                "borderRadius": "5px",
                                lineHeight: "36px",
                                textAlign: "center"
                            }, "text": ""
                        };
                        temp.style.top = (parseInt(temp.style.height) + 20) * col + "px";
                        col = col++ > howManyInAColumn - 2 ? 0 : col;
                        temp.style.left = this.$refs.dragContain.offsetWidth + ((parseInt(temp.style.width) + 10) * (Math.floor(i / howManyInAColumn))) + 10 + "px";
                        temp.text = student[i].name;
                        Object.assign(student[i], temp);
                        this.dataPack.students.push(student[i])
                    }
                    let call = Math.ceil(this.dataPack.students.length / howManyInAColumn);

                    this.contain.xx = this.$refs.dragContain.offsetWidth + (call * 100);
                    this.contain.yy = this.$refs.dragContain.offsetHeight;
                })

                await this.$api.sysSetting.selectSetting("persontemplet").then(data => {
                    if (!data.data.v) {
                        this.$dialog.alert("请先设置人员模板");
                        this.$router.push("/PersonnelTemplate");
                    } else {
                        this.dataPack.person = JSON.parse(data.data.v);
                    }
                })

                await this.$api.exam.examName(this.classId).then(data => {
                    if(data.flag){
                        this.examName.thisExamName = data.data.thisExamName
                        this.examName.lastExamName = data.data.lastExamName
                    }
                });
            },
            async initialize() {
                this.dataPack = {
                    json: [],
                    students: [],
                    person: [],
                    seats: [],
                };
                this.dataSavePack = {
                    temporarySeat: [],
                    studentSeatCorrespondence: [],
                };
                await this.init();
                for (let obj of this.dataPack.person) {
                    switch (obj.key) {
                        case "lastResult":
                            this.legendColor.lastResult = obj.style.color;
                            break;
                        case "result":
                            this.legendColor.result = obj.style.color;
                            break;
                        case "lastRank":
                            this.legendColor.lastRank = obj.style.color;
                            break;
                        case "rank":
                            this.legendColor.rank = obj.style.color;
                            break;
                    }
                }
                for (let obj of this.dataPack.json) {
                    switch (obj.key) {
                        case "stuCount":
                            obj.text = this.stuCount + "人" + this.getDate();
                            break;
                        case "className":
                            obj.text = "ET" + this.className;
                            break;
                        case "lastResult":
                            obj.style.color = this.legendColor.lastResult;
                            if(this.examName.lastExamName)
                                obj.text = this.examName.lastExamName;
                            break;
                        case "result":
                            obj.style.color = this.legendColor.result;
                            if(this.examName.thisExamName)
                                obj.text = this.examName.thisExamName;
                            break;
                        case "lastRank":
                            obj.style.color = this.legendColor.lastRank;
                            break;
                        case "rank":
                            obj.style.color = this.legendColor.rank;
                            break;
                    }
                }
                  console.log("我是返回的数据 this.dataSavePack.studentSeatCorrespondence=====",this.dataSavePack.studentSeatCorrespondence);
                    console.log("我是返回的数据 this.dataSavePack.temporarySeat=====",this.dataSavePack.temporarySeat);
                for (let ssc of this.dataSavePack.studentSeatCorrespondence) {
                    let seat;
                    console.log("我是返回的数据添加的数据进行中=",ssc.index);
                    if (ssc.isTemp) {
                        seat = this.dataSavePack.temporarySeat[ssc.index];
                    } else {
                        seat = this.dataPack.json[ssc.index];
                    }
                    let nameIndex;
                    for (let obj in this.dataPack.students) {
                        if (this.dataPack.students[obj].id == ssc.stuId) {
                            nameIndex = obj;
                        }
                    }
                    let people = arrayUtil.deepClone(this.dataPack.person);
                    console.log("我是打印的people+++++++++++++",people);
                     console.log("我是打印的seat+++++++++++++",seat);
                    for (let obj of people) {
                        obj.style.top = parseInt(obj.style.top) + parseInt(seat.style.top) + "px";
                        obj.style.left = parseInt(obj.style.left) + parseInt(seat.style.left) + "px";
                        obj.text = this.dataPack.students[nameIndex][obj.key];
                        obj.stuId = this.dataPack.students[nameIndex].id;
                    }
                    this.dataPack.seats.push(people);
                }
                this.markTransfer();
                this.overlay = false;
            },
            getDate(){
              let date = new Date();
              return date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();
            },
            // 字符串转json对象
            toJson(str) {
                let _str = eval('(' + str + ')');
                return _str;
            },
            //外层div点击选择事件 绑定右上角设置面板
            moveDiv(index, e) {
                let jsonNew = this.toJson('{"' + e.target.style.cssText.replace(/\; +/g, "\",\"").replace(/\: +/g, "\":\"").replace(/\;+/g, "").replace(/-\w/g, function ($) {
                    return $.slice(1).toUpperCase();
                }) + '"}');
                //当前选中div的序号
                this.selectDivIndex = index;

                // 设置div框的 各种属性
                for (let em in jsonNew) {
                    this.dataSavePack.temporarySeat[index].style[em] = jsonNew[em];
                }
            },
            //添加一个div块 默认的
            addDive() {
                let newJson = {
                    style: {
                        width: "60px",
                        height: "80px",
                        fontSize: "14px",
                        color: "#ffffff",
                        top: this.gridCalc(this.offsetY) + "px",
                        left: this.gridCalc(this.offsetX) + "px",
                        border: "1px solid rgb(0, 0, 0)",
                        backgroundColor: "rgb(255, 255, 255)",
                        borderRadius: "5px"
                    }
                };
                this.dataSavePack.temporarySeat.push(newJson);
            },
            //删除当前div
            del(i, e) {
                this.dataSavePack.temporarySeat.splice(i, 1);
                this.selectDivIndex = -1;
                e.stopPropagation();
            },
            onSave() {
                // console.log(this.json,'11')
                let seatSetting = this.dataSavePack;
                let classModel = this.dataPack.json;
                let seatSettingStatus = 0;
                if(this.dataSavePack.studentSeatCorrespondence.length != this.dataPack.students.length){
                    seatSettingStatus = 1;
                }
                this.$api.classList.updateSseatSetting({
                    id: this.classId,
                    classModel: JSON.stringify(classModel),
                    seatSetting: JSON.stringify(seatSetting),
                    seatSettingStatus: seatSettingStatus
                }).then(data => {
                    if (data.flag)
                        this.$dialog.alert("保存成功");
                })

            },
            showAddMenu(e) {
                this.x = e.clientX
                this.y = e.clientY
                this.offsetX = e.offsetX
                this.offsetY = e.offsetY
                this.addMenu = true
            },
            gridCalc(num) {
                return Math.floor((num + 5) / 10) * 10
            },
            clearSeat(index, num) {
                this.dataPack.seats.splice(index, 1);
                let i = -1;
                for (let j in this.dataSavePack.studentSeatCorrespondence) {
                    if (this.dataSavePack.studentSeatCorrespondence[j].stuId == num) {
                        i = j;
                        let ssc = this.dataSavePack.studentSeatCorrespondence[j];
                        if (!ssc.isTemp) {
                            this.dataPack.json[ssc.index].style.border = "1px solid rgb(0, 0, 0)";
                        } else {
                            this.dataSavePack.temporarySeat[ssc.index].style.border = "1px solid rgb(0, 0, 0)";
                        }
                        break;
                    }
                }
                this.dataSavePack.studentSeatCorrespondence.splice(i, 1);
            },
            showAddMenu(e) {
                this.x = e.clientX
                this.y = e.clientY
                this.offsetX = e.offsetX
                this.offsetY = e.offsetY
                this.addMenu = true
            },
            isContinue(flag, index) {
                for (let ssc of this.dataSavePack.studentSeatCorrespondence) {
                    if (ssc.isTemp == flag) {
                        if (ssc.index == index) {
                            return true;
                        }
                    }
                }
                return false;
            },
            markTransfer() {
                for (let ssc of this.dataSavePack.studentSeatCorrespondence) {
                    if (this.transferStaff[ssc.stuId]) {
                        if (!ssc.isTemp) {
                            this.dataPack.json[ssc.index].style.border = "2px solid rgb(0, 0, 255)";
                        } else {
                            this.dataSavePack.temporarySeat[ssc.index].style.border = "2px solid rgb(0, 0, 255)";
                        }
                    }
                }
            },
            async changeNameSwitch(){
                await this.initialize();
            },
        },
        computed: {
            studentShow(stuId) {
                return function (stuId) {
                    if (this.dataSavePack.studentSeatCorrespondence.length == 0) return true;
                    for (let stu of this.dataSavePack.studentSeatCorrespondence) {
                        if (stu.stuId == stuId) {
                            return false
                        }
                    }
                    return true;
                }
            }
        },
        directives: {
            drag: {
                bind: function (el, binding, vnode) {
                    let _this = vnode.context;
                    el.onmousedown = (e) => {
                        _this.originalLocation.left = el.style.left;
                        _this.originalLocation.top = el.style.top;
                        var disx = e.clientX - el.offsetLeft;
                        var disy = e.clientY - el.offsetTop;
                        document.onmousemove = function (e) {
                            let left = e.clientX - disx;
                            let top = e.clientY - disy;
                            _this.divindex = -1;
                            for (let i in _this.dataPack.json) {
                                if (i <= 9) continue;
                                if (_this.isContinue(false, i)) continue;
                                let x = parseInt(_this.dataPack.json[i].style.left);
                                let y = parseInt(_this.dataPack.json[i].style.top);
                                let w = parseInt(_this.dataPack.json[i].style.width);
                                let h = parseInt(_this.dataPack.json[i].style.height);
                                if ((left > x && left < (x + w)) && (top > y && top < (y + h))) {
                                    _this.divindex = i;
                                }
                            }
                            _this.selectDivIndex = -1;
                            for (let i in _this.dataSavePack.temporarySeat) {
                                if (_this.isContinue(true, i)) continue;
                                //if(_this.dataSavePack.temporarySeat[i].isActive) continue;
                                let x = parseInt(_this.dataSavePack.temporarySeat[i].style.left);
                                let y = parseInt(_this.dataSavePack.temporarySeat[i].style.top);
                                let w = parseInt(_this.dataSavePack.temporarySeat[i].style.width);
                                let h = parseInt(_this.dataSavePack.temporarySeat[i].style.height);
                                if ((left > x && left < (x + w)) && (top > y && top < (y + h))) {
                                    _this.selectDivIndex = i;
                                }
                            }

                            el.style.left = left + 'px';
                            el.style.top = top + 'px';
                        }
                        document.onmouseup = (e) => {
                            document.onmousemove = document.onmouseup = null;
                            if (_this.divindex == -1 && _this.selectDivIndex == -1) {
                                el.style.left = _this.originalLocation.left;
                                el.style.top = _this.originalLocation.top;
                            } else {
                                if (_this.nameIndex != -1) {
                                    let seat;
                                    let studentSeatCorrespondence = {
                                        stuId: _this.dataPack.students[_this.nameIndex].id,
                                        isTemp: false,
                                        index: -1
                                    };

                                    if (_this.divindex != -1) {
                                        studentSeatCorrespondence.index = _this.divindex;
                                        seat = _this.dataPack.json[_this.divindex];
                                    } else if (_this.selectDivIndex != -1) {
                                        studentSeatCorrespondence.isTemp = true;
                                        studentSeatCorrespondence.index = _this.selectDivIndex;
                                        seat = _this.dataSavePack.temporarySeat[_this.selectDivIndex];
                                    } else {
                                        return;
                                    }
                                    _this.dataSavePack.studentSeatCorrespondence.push(studentSeatCorrespondence);
                                    let people = arrayUtil.deepClone(_this.dataPack.person);
                                    for (let obj of people) {
                                        obj.style.top = parseInt(obj.style.top) + parseInt(seat.style.top) + "px";
                                        obj.style.left = parseInt(obj.style.left) + parseInt(seat.style.left) + "px";
                                        obj.text = _this.dataPack.students[_this.nameIndex][obj.key];
                                        obj.stuId = _this.dataPack.students[_this.nameIndex].id;
                                    }
                                    _this.dataPack.seats.push(people);
                                }
                                _this.nameIndex = -1;
                                _this.divindex = -1;
                                _this.selectDivIndex = -1;
                                el.style.left = _this.originalLocation.left;
                                el.style.top = _this.originalLocation.top;
                                _this.markTransfer();
                            }
                        }
                    }

                },
            },
            drag2: {
                bind: function (el, binding, vnode) {
                    let _this = vnode.context;
                    el.onmousedown = (e) => {
                        var disx = e.clientX - el.offsetLeft;
                        var disy = e.clientY - el.offsetTop;
                        for (let obj of _this.dataSavePack.studentSeatCorrespondence) {
                            if (obj.isTemp) {
                                if (_this.selectDivIndex == obj.index) {
                                    return;
                                }
                            }
                        }
                        document.onmousemove = function (e) {
                            let left = e.clientX - disx;
                            let top = e.clientY - disy;
                            if (left < 0) {
                                left = 0;
                            }
                            if (top < 0) {
                                top = 0;
                            }
                            if (left > binding.value.xx - el.offsetWidth) {
                                left = binding.value.xx - el.offsetWidth;
                            }
                            if (top > binding.value.yy - el.offsetHeight) {
                                top = binding.value.yy - el.offsetHeight;
                            }
                            left = Math.floor((left + 5) / 10) * 10;
                            top = Math.floor((top + 5) / 10) * 10;
                            el.style.left = left + 'px';
                            el.style.top = top + 'px';
                        }
                        document.onmouseup = function () {
                            document.onmousemove = document.onmouseup = null;
                        }
                    }

                },
            }
        }
    }
</script>

<style lang='scss' scoped>
    ul, li {
        margin: 0px;
        list-style: none;
        padding: 0px;
    }

    .contain {
        height: 209.8mm;
        position: relative;
        user-select: none;
        width: 297mm;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);
    }

    .el-form-item--mini.el-form-item {
        margin-bottom: 7px;
    }

    .drag {
        //width: 100px;
        //height: 100px;
        position: absolute;
        top: 0;
        left: 0;
        cursor: move;
        background-color: red;
        border: 1px solid #FFF;
        //line-height: 1.7;
        box-sizing: border-box;
        color: #fff;
        overflow: hidden;
        //padding: 5px;

        .sacle {
            position: absolute;
            right: 0px;
            bottom: 0px;
            background-color: #909399;
            cursor: se-resize;
            font-size: 15px;
        }

        .del {
            position: absolute;
            top: 0px;
            right: 0px;
            padding: 2px;
            box-shadow: none;
        }
    }

    .drag.active {
        border-radius: 5px;
        border: 1px solid #85ce61;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);

    }

    .control {
        width: 250px;
        border-radius: 5px;
        overflow: hidden;
        background-color: #B3C0D1;
        position: absolute;
        z-index: 999;
        right: 20px;
        top: 15px;
    }
</style>

